export default {
    error : {
        textAlign: 'center'
    }
}